import img1 from "../assets/asset_1.jpg";
import img2 from "../assets/asset_13.png";
import TeamCard from "../components/team.component";

const Team = () => {
  return (
    <div
      id="team"
      className="d-flex flex-column justify-content-center align-items-center text-center my-5 position-relative"
      style={{
        scrollMarginTop: 100,
        zIndex: 1,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
          width: " 100%",
          height: "100%",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1549068106-b024baf5062d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(125px) brightness(0.45) contrast(1.75)",
        }}
      />
      <img src={img2} className="hovering-img" alt="" />
      <h1
        data-aos="fade-up"
        data-aos-duration="700"
        className="primary-h"
        style={{ marginTop: 40 }}
      >
        Team
      </h1>
      <br />
      <div className="row justify-content-center">
        <div
          className="col-md"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
        >
          <TeamCard
            source={img1}
            name={"Marcos"}
            title={"Alchemist, Creator, Art Director, Writer, Curator"}
          />
        </div>
      </div>
    </div>
  );
};

export default Team;
